<script>
  export let flipX;
  export let flipY;
  export let height;

  $: width = height / 200 * 1350;
  const scaleX = flipX ? -1 : 1;
  const scaleY = flipY ? -1 : 1;

  const translateX = flipX ? -1350 : 0;
  const translateY = flipY ? -200 : 0;
</script>

<style>
  svg path, svg rect {
    fill: white;
    stroke: white;
    stroke-width: 2px;
    stroke-linejoin: round;
  }
</style>

<svg width="{width}" height="{height}" viewBox="0 0 1350 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g transform='scale({scaleX} {scaleY}) translate({translateX} {translateY})'>
    <path d="M1100 150L1050 150L1050 100L1100 150Z" fill="white"/>
    <path d="M1000 200L950 200L1000 150L1000 200Z" fill="white"/>
    <path d="M1000 150L950 100L1000 100L1000 150Z" fill="white"/>
    <path d="M1050 200L1050 150L1100 150L1050 200Z" fill="white"/>
    <rect x="1050" y="200" width="50" height="50" transform="rotate(-180 1050 200)" fill="white"/>
    <rect x="1050" y="150" width="50" height="50" transform="rotate(-180 1050 150)" fill="white"/>
    <path d="M1300 0L1300 50L1250 50L1300 0Z" fill="white"/>
    <path d="M1350 100L1350 150L1300 100L1350 100Z" fill="white"/>
    <path d="M1300 100L1250 150L1250 100L1300 100Z" fill="white"/>
    <path d="M1350 50L1300 50L1300 -2.18557e-06L1350 50Z" fill="white"/>
    <rect x="1350" y="50" width="50" height="50" transform="rotate(90 1350 50)" fill="white"/>
    <rect x="1300" y="50" width="50" height="50" transform="rotate(90 1300 50)" fill="white"/>
    <path d="M1000 50H1050V100L1000 50Z" fill="white"/>
    <path d="M1100 0H1150L1100 50V0Z" fill="white"/>
    <path d="M1100 50L1150 100H1100V50Z" fill="white"/>
    <path d="M1050 0V50H1000L1050 0Z" fill="white"/>
    <rect x="1050" width="50" height="50" fill="white"/>
    <rect x="1050" y="50" width="50" height="50" fill="white"/>
    <path d="M900 0L900 50L850 50L900 0Z" fill="white"/>
    <path d="M950 100L950 150L900 100L950 100Z" fill="white"/>
    <path d="M900 100L850 150L850 100L900 100Z" fill="white"/>
    <path d="M950 50L900 50L900 -2.18557e-06L950 50Z" fill="white"/>
    <rect x="950" y="50" width="50" height="50" transform="rotate(90 950 50)" fill="white"/>
    <rect x="900" y="50" width="50" height="50" transform="rotate(90 900 50)" fill="white"/>
    <path d="M1200 200L1200 150L1250 150L1200 200Z" fill="white"/>
    <path d="M1150 100L1150 50L1200 100L1150 100Z" fill="white"/>
    <path d="M1200 100L1250 50L1250 100L1200 100Z" fill="white"/>
    <path d="M1150 150L1200 150L1200 200L1150 150Z" fill="white"/>
    <rect x="1150" y="150" width="50" height="50" transform="rotate(-90 1150 150)" fill="white"/>
    <rect x="1200" y="150" width="50" height="50" transform="rotate(-90 1200 150)" fill="white"/>
    <path d="M800 200L800 150L850 150L800 200Z" fill="white"/>
    <path d="M750 100L750 50.0001L800 100L750 100Z" fill="white"/>
    <path d="M800 100L850 50.0001L850 100L800 100Z" fill="white"/>
    <path d="M750 150L800 150L800 200L750 150Z" fill="white"/>
    <rect x="750" y="150" width="50" height="50" transform="rotate(-90 750 150)" fill="white"/>
    <rect x="800" y="150" width="50" height="50" transform="rotate(-90 800 150)" fill="white"/>
    <path d="M750 50L700 50L700 -4.37114e-06L750 50Z" fill="white"/>
    <path d="M650 100L600 100L650 50L650 100Z" fill="white"/>
    <path d="M650 50L600 -4.37114e-06L650 0L650 50Z" fill="white"/>
    <path d="M700 100L700 50L750 50L700 100Z" fill="white"/>
    <rect x="700" y="100" width="50" height="50" transform="rotate(-180 700 100)" fill="white"/>
    <rect x="700" y="50" width="50" height="50" transform="rotate(-180 700 50)" fill="white"/>
    <path d="M200 50.0001L250 50.0001L250 100L200 50.0001Z" fill="white"/>
    <path d="M300 0.00012207L350 0.000126441L300 50.0001L300 0.00012207Z" fill="white"/>
    <path d="M300 50.0001L350 100L300 100L300 50.0001Z" fill="white"/>
    <path d="M250 0.000126441L250 50.0001L200 50.0001L250 0.000126441Z" fill="white"/>
    <rect x="250" y="0.00012207" width="50" height="50" fill="white"/>
    <rect x="250" y="50.0001" width="50" height="50" fill="white"/>
    <path d="M550 200L550 150L500 150L550 200Z" fill="white"/>
    <path d="M600 100L600 50.0001L550 100L600 100Z" fill="white"/>
    <path d="M550 100L500 50.0001L500 100L550 100Z" fill="white"/>
    <path d="M600 150L550 150L550 200L600 150Z" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 600 150)" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 550 150)" fill="white"/>
    <path d="M400 150H350V100L400 150Z" fill="white"/>
    <path d="M300 200H250L300 150V200Z" fill="white"/>
    <path d="M300 150L250 100H300V150Z" fill="white"/>
    <path d="M350 200V150H400L350 200Z" fill="white"/>
    <rect x="350" y="200" width="50" height="50" transform="rotate(-180 350 200)" fill="white"/>
    <rect x="350" y="150" width="50" height="50" transform="rotate(-180 350 150)" fill="white"/>
    <path d="M150 200L150 150L100 150L150 200Z" fill="white"/>
    <path d="M200 100L200 50.0001L150 100L200 100Z" fill="white"/>
    <path d="M150 100L100 50.0001L100 100L150 100Z" fill="white"/>
    <path d="M200 150L150 150L150 200L200 150Z" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 200 150)" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 150 150)" fill="white"/>
    <path d="M450 0.00012207L450 50.0001L500 50.0001L450 0.00012207Z" fill="white"/>
    <path d="M400 100L400 150L450 100L400 100Z" fill="white"/>
    <path d="M450 100L500 150L500 100L450 100Z" fill="white"/>
    <path d="M400 50.0001L450 50.0001L450 0.000115514L400 50.0001Z" fill="white"/>
    <rect width="50" height="50" transform="matrix(1.31134e-07 1 1 -1.31134e-07 400 50.0001)" fill="white"/>
    <rect width="50" height="50" transform="matrix(1.31134e-07 1 1 -1.31134e-07 450 50.0001)" fill="white"/>
    <path d="M50 0L50 50L100 50L50 0Z" fill="white"/>
    <path d="M0 100L-2.18557e-06 150L50 100L0 100Z" fill="white"/>
    <path d="M50 100L100 150L100 100L50 100Z" fill="white"/>
    <path d="M-2.18557e-06 50L50 50L50 2.18557e-06L-2.18557e-06 50Z" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 50)" fill="white"/>
    <rect width="50" height="50" transform="matrix(-4.37114e-08 1 1 4.37114e-08 50 50)" fill="white"/>
  </g>
</svg>
